




































































import { Component, Watch, Vue } from 'vue-property-decorator'
import queryString from 'query-string'
import memoize from 'lodash/memoize'
import debounce from 'lodash/debounce'
import { Image } from '@/types/image'
import PixabayModule from '@/store/modules/pixabay'

@Component({})
export default class GroupImageSelector extends Vue {
    wait: boolean = true
    input: string = ''
    selectedImage: Image | null = null

    get loading(): boolean {
        return PixabayModule.loading || this.wait
    }

    get images(): Image[] {
        return PixabayModule.images
    }

    async created() {
        setTimeout(() => {
            this.wait = false
        }, 300)

        this.input = PixabayModule.searchStr
        this.selectedImage = PixabayModule.selectedImage
        if (!PixabayModule.searchStr) {
            await this.search(this.input)
        }
    }

    async destroyed() {
        await PixabayModule.cleanupImages()
    }

    @Watch('input')
    onInput() {
        const input = this.input.trim()
        this.debouncedSearch(input)
    }

    debouncedSearch = debounce(this.search, 300)
    async search(input: string) {
        PixabayModule.search(input)
    }

    goBack() {
        this.$emit('goBack')
    }

    selectImage(image: Image) {
        this.selectedImage = image
        PixabayModule.setSelectedImageAction(image)
        this.$emit('selectedImage', image)
    }

    onClear() {
        this.input = ''

        const $input = this.$refs.input as HTMLInputElement
        $input.focus()
    }
}
